var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-tooltip',{attrs:{"bottom":"","max-width":"300","color":"rgba(0,0,0,1)"},scopedSlots:_vm._u([{key:"activator",fn:function(ref){
var on = ref.on;
return [_c('v-chip',_vm._g({staticClass:"my-1 ml-3",attrs:{"dark":_vm.dark,"color":_vm.color}},on),[_vm._v(_vm._s(_vm.title)+": "+_vm._s(_vm.value))])]}}])},[_vm._v(" "+_vm._s(_vm.description)+" ")])}
var staticRenderFns = []

export { render, staticRenderFns }